import { _MiscMessages, ConfigSystemParams, MdmDashboardWidgetTitles, MdmDeviceClass } from 'src/app/core/consts';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { catchError, combineLatest, debounceTime, distinctUntilChanged, Observable, of, startWith, Subject, switchMap, takeUntil } from 'rxjs';
import { ChartConfigService } from 'src/app/core/services/utelize/general/chart-config-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { IntegerResultAndStringResultDTO } from 'src/app/core/interfaces/general/integer-result-and-string-result';
import { MdmDevicesIntuneStatsService } from 'src/app/core/services/utelize/system/device-management/mdm-devices-intune-stats-service';
import { OurDate } from 'src/app/core/interfaces/general/our-date';
import { mdmUserDomainsDisplayText } from 'src/app/core/functions-generic/functions-generic-mdm';
import { populateOurDate } from 'src/app/core/functions-generic/functions-generic-date';
import { TippyToolTipService } from 'src/app/core/services/utelize/general/tippy-tool-tip-service';
import { WidgetRowChartType } from '../widget-row-chart-type.model';
import { WidgetService } from 'src/app/core/services/utelize/general/widget-service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-widget-row-mdm-devices-03',
  templateUrl: './widget-row-mdm-devices-03.component.html',
  styleUrls: ['./widget-row-mdm-devices-03.component.scss'],
  providers: [TippyToolTipService]
})

export class WidgetRowMdmDevices03Component implements AfterViewInit, OnChanges, OnDestroy, OnInit {

  @Input() actionButton0Show  : boolean | undefined;
  @Input() actionButton0Text  : string  | undefined;
  @Input() allowContainerClose: boolean | undefined;
  @Input() containerTitle     : string  | undefined;
  @Input() deviceClass        : string  | undefined;
  @Input() marginBottom       : string  | undefined="mb-0";
  @Input() previousSync       : boolean | undefined=false;
  @Input() useContainer       : boolean | undefined;
  @Input() showTitleHintText  : boolean | undefined;
  @Input() userDomains        : string  | undefined;
    
  @Output() actionButton0Click: EventEmitter<void                                  >=new EventEmitter<void                                  >();
  @Output() containerClosed   : EventEmitter<void                                  >=new EventEmitter<void                                  >();
  @Output() legendClick       : EventEmitter<{chartName: string, labelText: string}>=new EventEmitter<{chartName: string, labelText: string}>();
  @Output() userDomainsClear  : EventEmitter<void                                  >=new EventEmitter<void                                  >();

  get isOtherClass     () { return this.deviceClass===MdmDeviceClass.other                            ; }
  get userDomainsText  () { return mdmUserDomainsDisplayText(this.exceptionsService, this.userDomains); }
  get visibleChartCount() { return this.isOtherClass ? 2 : 5                                          ; }
    
  get countsInLegend() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.WidgetRow_IncludeCountsInLegend_MdmDevices03, false); }
  get pollingWidgets() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.WidgetRow_Polling_MdmDevices03,               false); }
   
  get maxChartHeight  () { return this.configSystemService.getValueAsInteger(ConfigSystemParams.WidgetRow_MaxChartHeight_MdmDevices03,   333); } 
  get maxWidgetsPerRow() { return this.configSystemService.getValueAsInteger(ConfigSystemParams.WidgetRow_MaxWidgetsPerRow_MdmDevices03, 5  ); }

  private filterCompanyID: number  | undefined;
  private filterDate     : OurDate | undefined=populateOurDate(this.exceptionsService, Date.now());
  private lastDataByChart: Map<string, IntegerResultAndStringResultDTO[]>=new Map<string, IntegerResultAndStringResultDTO[]>();
  
  private destroy$  =new Subject<void>();
  private selection$=new Subject<{ companyId: number; date: { year: number; month: number; day: number }; refreshToken?: number; }>();
  
  public devicesByCarrierChart!       : WidgetRowChartType;
  public devicesByCarrierCounts       : number[]=[];
  public devicesByCompanyManagedChart!: WidgetRowChartType;
  public devicesByCompanyManagedCounts: number[]=[];
  public devicesByEncryptedChart!     : WidgetRowChartType;
  public devicesByEncryptedCounts     : number[]=[];
  public devicesByJailbrokenChart!    : WidgetRowChartType;
  public devicesByJailbrokenCounts    : number[]=[];
  public devicesBySupervisedChart!    : WidgetRowChartType;
  public devicesBySupervisedCounts    : number[]=[];
  public expandContainer              : boolean=true;
  public loadingCharts                 : Set<string>=new Set<string>(this.allChartNames());
  public syncInfoText                 : string="";
  public visibleContainer             : boolean=true;
  
  public readonly chartTitles=MdmDashboardWidgetTitles;

  constructor(
    private changeDetectorRef           : ChangeDetectorRef,
    private configSystemService         : ConfigSystemService,
    private exceptionsService           : ExceptionsService,
    private mdmDevicesIntuneStatsService: MdmDevicesIntuneStatsService,
    private tippyToolTipService         : TippyToolTipService,
    private widgetService               : WidgetService,

    public chartConfigService: ChartConfigService
  ) {

  }

  public ngOnInit(): void {
    try {
      this.initSelectionStream();
      
      if (!this.containerTitle || this.containerTitle.trim()=="")
        this.containerTitle=_MiscMessages.TitleNotSet;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnChanges(changes: SimpleChanges): void {
    try {
      if (((changes['deviceClass'] && !changes['deviceClass'].firstChange)
           || (changes['userDomains'] && !changes['userDomains'].firstChange)
          ) && (this.filterCompanyID ?? -1)!=-1)
        this.refreshWidgets();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.tippyToolTipService.chartTippyDestroy();

      this.destroy$.next();
      this.destroy$.complete();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshWidgets(): void {
    try {
      const companyId=this.filterCompanyID ?? -1;
      const date     ={
        year : <number>(this.filterDate?.year  ?? 1),
        month: <number>(this.filterDate?.month ?? 1),
        day  : <number>(this.filterDate?.day   ?? 1),
      };
  
      this.selection$.next({ companyId, date, refreshToken: Date.now() });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private initSelectionStream(): void {
    try {
      this.selection$
      .pipe(
        debounceTime(150),
        distinctUntilChanged((a, b) =>
          a.companyId   ===b.companyId  &&
          a.date.year   ===b.date.year  &&
          a.date.month  ===b.date.month &&
          a.date.day    ===b.date.day   &&
          a.refreshToken===b.refreshToken
        ),
        switchMap(selected => {
          const companyId=selected.companyId;
          const year     =selected.date.year;
          const month    =selected.date.month;
          const day      =selected.date.day;
          
          const safeStart=<T>(observable: Observable<T>, fallback: T) =>
            observable.pipe(
              startWith(<T | null>null),
              catchError(err => {
                this.exceptionsService.handleException(new Error(this.exceptionsService.formatHttpError(err)));
                return of(fallback);
              })
            );
          
          const devicesByCarrierSource=this.pollingWidgets
                                       ? this.widgetService.getIntuneDevicesByCarrierUpdates(companyId, this.previousSync ?? false, this.deviceClass, this.userDomains)
                                       : this.widgetService.getIntuneDevicesByCarrier       (companyId, this.previousSync ?? false, this.deviceClass, this.userDomains);

          const devicesByCompanyManagedSource=this.pollingWidgets
                                              ? this.widgetService.getIntuneDevicesByCompanyManagedUpdates(companyId, this.previousSync ?? false, this.deviceClass, this.userDomains)
                                              : this.widgetService.getIntuneDevicesByCompanyManaged       (companyId, this.previousSync ?? false, this.deviceClass, this.userDomains);

          const devicesByEncryptedSource=this.pollingWidgets
                                         ? this.widgetService.getIntuneDevicesByEncryptedUpdates(companyId, this.previousSync ?? false, this.deviceClass, this.userDomains)
                                         : this.widgetService.getIntuneDevicesByEncrypted       (companyId, this.previousSync ?? false, this.deviceClass, this.userDomains);

          const devicesByJailbrokenSource=this.pollingWidgets
                                          ? this.widgetService.getIntuneDevicesByJailbrokenUpdates(companyId, this.previousSync ?? false, this.deviceClass, this.userDomains)
                                          : this.widgetService.getIntuneDevicesByJailbroken       (companyId, this.previousSync ?? false, this.deviceClass, this.userDomains);

          const devicesBySupervisedSource=this.pollingWidgets
                                          ? this.widgetService.getIntuneDevicesBySupervisedUpdates(companyId, this.previousSync ?? false, this.deviceClass, this.userDomains)
                                          : this.widgetService.getIntuneDevicesBySupervised       (companyId, this.previousSync ?? false, this.deviceClass, this.userDomains);

          return combineLatest({
            devicesByCarrier       : safeStart(devicesByCarrierSource,        []),
            devicesByCompanyManaged: safeStart(devicesByCompanyManagedSource, []),
            devicesByEncrypted     : safeStart(devicesByEncryptedSource,      []),
            devicesByJailbroken    : safeStart(devicesByJailbrokenSource,     []),
            devicesBySupervised    : safeStart(devicesBySupervisedSource,     []),
          });
          // .pipe(
          //   catchError((error) => {
          //     this.exceptionsService.handleException(new Error(this.exceptionsService.formatHttpError(error)));
          //     return EMPTY; //👈 CRN_20260110 - If one fails, nothing is returned
          //   })
          // );
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(result => {
        this.applyDevicesByCarrier       (result.devicesByCarrier);
        this.applyDevicesByCompanyManaged(result.devicesByCompanyManaged);
        this.applyDevicesByEncrypted     (result.devicesByEncrypted);
        this.applyDevicesByJailbroken    (result.devicesByJailbroken);
        this.applyDevicesBySupervised    (result.devicesBySupervised);
        this.changeDetectorRef.markForCheck();
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public emitSelection(filterCompanyID: number | undefined, filterDate: OurDate | undefined): void {
    try {
      this.devicesByCarrierChart       =undefined!;
      this.devicesByCompanyManagedChart=undefined!;
      this.devicesByEncryptedChart     =undefined!;
      this.devicesByJailbrokenChart    =undefined!;
      this.devicesBySupervisedChart    =undefined!;
      this.filterCompanyID             =filterCompanyID;
      this.filterDate                  =filterDate;
      this.loadingCharts               =new Set<string>(this.allChartNames());

      const companyId=this.filterCompanyID ?? -1;
      const date     ={
        year : <number>(this.filterDate?.year  ?? 1),
        month: <number>(this.filterDate?.month ?? 1),
        day  : <number>(this.filterDate?.day   ?? 1),
      };
      
      this.selection$.next({ companyId, date });

      if (this.previousSync)
        this.getSyncedByInfo_Previous();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getSyncedByInfo_Previous(): void {
    try {
      const companyID: number=this.filterCompanyID ?? 0;

      if (companyID<=0) {
        this.syncInfoText="";
        return;
      }

      this.mdmDevicesIntuneStatsService.getSyncedByInfo_Previous(companyID)
      .pipe(
        catchError((error) => {
          this.exceptionsService.handleException(new Error(this.exceptionsService.formatHttpError(error)));
          return of(null);
        })
      )
      .subscribe({
        next: data => {
          if (!data?.dateResult) {
            this.syncInfoText="Unsynced";
            this.changeDetectorRef.markForCheck();
            return;
          }

          const date     =new Date(data.dateResult);
          const pad      =(n: number) => n.toString().padStart(2, '0');
          const formatted=`${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ` +
                          `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;

          this.syncInfoText=data?.stringResult
                            ? `${formatted} by ${data.stringResult}`
                            : `${formatted}`;
          this.changeDetectorRef.markForCheck();
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyDevicesByCarrier(data: IntegerResultAndStringResultDTO[] | null) {
    try {
      if (data===null)
        return;

      if (this.lastDataByChart.get(MdmDashboardWidgetTitles.devicesByCarrier)===data)
        return;

      this.lastDataByChart.set(MdmDashboardWidgetTitles.devicesByCarrier, data);

      this.applyPieChart(MdmDashboardWidgetTitles.devicesByCarrier,
                         () => this.chartConfigService.createPieChart<IntegerResultAndStringResultDTO>
                                                                     (MdmDashboardWidgetTitles.devicesByCarrier,
                                                                      "donut",
                                                                      data,
                                                                      x => x.stringResult,
                                                                      x => x.integerResult,
                                                                      this.maxChartHeight,
                                                                      this.countsInLegend,
                                                                      (target, html) => this.tippyToolTipService.chartTippyShow(target, html),
                                                                      () => this.tippyToolTipService.chartTippyHide(),
                                                                      (chartRef, rawLabel) => this.onLegendClick(chartRef, rawLabel),
                                                                      "categorical"),
                               chart => this.devicesByCarrierChart=chart
                        );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyDevicesByCompanyManaged(data: IntegerResultAndStringResultDTO[] | null) {
    try {
      if (data===null)
        return;

      if (this.lastDataByChart.get(MdmDashboardWidgetTitles.devicesByCompanyManaged)===data)
        return;

      this.lastDataByChart.set(MdmDashboardWidgetTitles.devicesByCompanyManaged, data);

      this.applyPieChart(MdmDashboardWidgetTitles.devicesByCompanyManaged,
                         () => this.chartConfigService.createPieChart<IntegerResultAndStringResultDTO>
                                                                     (MdmDashboardWidgetTitles.devicesByCompanyManaged,
                                                                      "donut",
                                                                      data,
                                                                      x => x.stringResult,
                                                                      x => x.integerResult,
                                                                      this.maxChartHeight,
                                                                      this.countsInLegend,
                                                                      (target, html) => this.tippyToolTipService.chartTippyShow(target, html),
                                                                      () => this.tippyToolTipService.chartTippyHide(),
                                                                      (chartRef, rawLabel) => this.onLegendClick(chartRef, rawLabel),
                                                                      "categorical"),
                               chart => this.devicesByCompanyManagedChart=chart
                        );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyDevicesByEncrypted(data: IntegerResultAndStringResultDTO[] | null) {
    try {
      if (data===null)
        return;

      if (this.lastDataByChart.get(MdmDashboardWidgetTitles.devicesByEncrypted)===data)
        return;

      this.lastDataByChart.set(MdmDashboardWidgetTitles.devicesByEncrypted, data);

      this.applyPieChart(MdmDashboardWidgetTitles.devicesByEncrypted,
                         () => this.chartConfigService.createPieChart<IntegerResultAndStringResultDTO>
                                                                     (MdmDashboardWidgetTitles.devicesByEncrypted,
                                                                      "donut",
                                                                      data,
                                                                      x => x.stringResult,
                                                                      x => x.integerResult,
                                                                      this.maxChartHeight,
                                                                      this.countsInLegend,
                                                                      (target, html) => this.tippyToolTipService.chartTippyShow(target, html),
                                                                      () => this.tippyToolTipService.chartTippyHide(),
                                                                      (chartRef, rawLabel) => this.onLegendClick(chartRef, rawLabel),
                                                                      "status-encrypted"),
                               chart => this.devicesByEncryptedChart=chart
                        );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyDevicesByJailbroken(data: IntegerResultAndStringResultDTO[] | null) {
    try {
      if (data===null)
        return;

      if (this.lastDataByChart.get(MdmDashboardWidgetTitles.devicesByJailbroken)===data)
        return;

      this.lastDataByChart.set(MdmDashboardWidgetTitles.devicesByJailbroken, data);

      this.applyPieChart(MdmDashboardWidgetTitles.devicesByJailbroken,
                         () => this.chartConfigService.createPieChart<IntegerResultAndStringResultDTO>
                                                                     (MdmDashboardWidgetTitles.devicesByJailbroken,
                                                                      "donut",
                                                                      data,
                                                                      x => x.stringResult,
                                                                      x => x.integerResult,
                                                                      this.maxChartHeight,
                                                                      this.countsInLegend,
                                                                      (target, html) => this.tippyToolTipService.chartTippyShow(target, html),
                                                                      () => this.tippyToolTipService.chartTippyHide(),
                                                                      (chartRef, rawLabel) => this.onLegendClick(chartRef, rawLabel),
                                                                      "status-jailbroken"),
                               chart => this.devicesByJailbrokenChart=chart
                        );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyDevicesBySupervised(data: IntegerResultAndStringResultDTO[] | null) {
    try {
      if (data===null)
        return;

      if (this.lastDataByChart.get(MdmDashboardWidgetTitles.devicesBySupervised)===data)
        return;

      this.lastDataByChart.set(MdmDashboardWidgetTitles.devicesBySupervised, data);

      this.applyPieChart(MdmDashboardWidgetTitles.devicesBySupervised,
                         () => this.chartConfigService.createPieChart<IntegerResultAndStringResultDTO>
                                                                     (MdmDashboardWidgetTitles.devicesBySupervised,
                                                                      "donut",
                                                                      data,
                                                                      x => x.stringResult,
                                                                      x => x.integerResult,
                                                                      this.maxChartHeight,
                                                                      this.countsInLegend,
                                                                      (target, html) => this.tippyToolTipService.chartTippyShow(target, html),
                                                                      () => this.tippyToolTipService.chartTippyHide(),
                                                                      (chartRef, rawLabel) => this.onLegendClick(chartRef, rawLabel),
                                                                      "status-supervised"),
                               chart => this.devicesBySupervisedChart=chart
                        );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyPieChart(chartName: string, build: () => any, assign: (chart: any) => void): void {
    try {
      this.chartConfigService.applyPieChart(
        chartName,
        build,
        (chart) => { assign(chart); this.changeDetectorRef.markForCheck(); },
        (loading) => { this.setChartLoading(chartName, loading); this.changeDetectorRef.markForCheck(); }
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private allChartNames(): string[] {
    try {
      return [
        MdmDashboardWidgetTitles.devicesByCarrier,
        MdmDashboardWidgetTitles.devicesByCompanyManaged,
        MdmDashboardWidgetTitles.devicesByEncrypted,
        MdmDashboardWidgetTitles.devicesByJailbroken,
        MdmDashboardWidgetTitles.devicesBySupervised
      ];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  public isChartLoading(chartName: string): boolean {
    try {
      return this.loadingCharts.has(chartName);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private setChartLoading(chartName: string, loading: boolean): void {
    try {
      const next=new Set<string>(this.loadingCharts);

      if (loading)
        next.add(chartName);
      else
        next.delete(chartName);

      this.loadingCharts=next;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  get rowColsClass(): string {
    try {
      const raw              =this.maxWidgetsPerRow;
      const widgetsPerRow    =(Number.isFinite(raw) && raw > 0) ? raw : 4;
      const safeWidgetsPerRow=Math.max(1, Math.min(6, widgetsPerRow, this.visibleChartCount));
  
      return `row-cols-1 row-cols-md-${safeWidgetsPerRow}`;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "row-cols-1 row-cols-md-4";
    }
  }

  public onLegendClick(chartRef: any, labelText: string): void {
    try {
      const chartName=chartRef?.opts?.chart?._chartName
                      ?? chartRef?._chartName
                      ?? chartRef?.chart?._chartName
                      ?? "unknown";

      // alert(`WidgetRowMdmDevices01Component\nChart: ${chartName} | Label: ${labelText}`); return;

      this.legendClick.emit({chartName, labelText});
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public actionButton0OnClick(): void {
    try {
      this.actionButton0Click.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public toggleContainerExpansion(): void {
    try {
      this.expandContainer=!this.expandContainer;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public collapseContainer(): void {
    try {
      this.expandContainer=false;
      this.changeDetectorRef.markForCheck();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public closeContainer(): void {
    try {
      this.visibleContainer=false;
      this.containerClosed.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public restoreContainer(): void {
    try {
      this.visibleContainer=true;
      this.changeDetectorRef.markForCheck();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
